import type { Ref } from 'vue'
import { inject, provide, ref } from 'vue'

interface SidebarState {
  open: Ref<boolean>
  setOpen: (open: boolean) => void
  toggleSidebar: () => void
}

const SIDEBAR_LARGE_BREAKPOINT = 1024

const SidebarSymbol = Symbol('sidebar')

export function createSidebar(): SidebarState {
  const open = ref(getSidebarState())

  function getSidebarState(): boolean {
    if (typeof document === 'undefined') {
      return false
    }

    return window.innerWidth < SIDEBAR_LARGE_BREAKPOINT
  }

  function setOpen(newOpen: boolean): void {
    open.value = newOpen
  }

  function toggleSidebar(): void {
    setOpen(!open.value)
  }

  return {
    open,
    setOpen,
    toggleSidebar,
  }
}

export function provideSidebar(state: SidebarState): void {
  provide(SidebarSymbol, state)
}

export function useSidebar(): SidebarState {
  const sidebar = inject<SidebarState>(SidebarSymbol)
  if (!sidebar) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return sidebar
}
